import { InjectionToken, Type } from '@angular/core';

export const WIRE_CUT_PRODUCT_DETAIL_VIEW_COMPONENTS = new InjectionToken<Type<unknown>[]>('WIRE_CUT_PRODUCT_DETAIL_VIEW_COMPONENTS', {
  providedIn: 'root',
  factory: () => [],
});

export const WIRE_CUT_PRODUCT_RESULT_VIEW_COMPONENTS = new InjectionToken<Type<unknown>[]>('WIRE_CUT_PRODUCT_RESULT_VIEW_COMPONENTS', {
  providedIn: 'root',
  factory: () => [],
});
